import { IconButton, Tooltip } from '@mui/material';
import { MouseEventHandler } from 'react';
import { Iconify } from 'src/components/iconify';
import { useLocales } from 'src/locales';

type Props = {
  pinned: boolean | undefined;
  onClick: MouseEventHandler;
};

export const PinAction = ({ pinned, onClick }: Props) => {
  const { translate } = useLocales();
  return (
    <Tooltip
      title={
        pinned
          ? translate('communicate.chat.unpin')
          : translate('shared.buttons.pin')
      }
    >
      <IconButton
        size="small"
        sx={pinned ? {} : { transform: 'rotate(315deg)' }}
        onClick={onClick}
      >
        <Iconify icon={pinned ? 'tabler:pinned-off' : 'tabler:pin'} />
      </IconButton>
    </Tooltip>
  );
};
